import { SET_LOADING } from "../type";

export const setLoading = () => ({
  type: SET_LOADING,
});